import { render, staticRenderFns } from "./RemoteFolderConfigurationForm.vue?vue&type=template&id=5821d63e&"
import script from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"
export * from "./RemoteFolderConfigurationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports